import React from 'react';

const Hero = React.forwardRef((props, ref) => (
  <section 
    id="hero" 
    ref={ref} 
    data-animate
    className="min-h-screen bg-gradient-to-br from-blue-600 to-purple-600 text-white flex items-center justify-center p-8"
  >
    <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
      <div className="text-center md:text-left max-w-2xl">
        <h1 className="text-5xl md:text-6xl font-bold mb-4 animate-pulse">
          Joseph Drozd - Glitch Doctor 
        </h1>
        <h2 className="text-2xl md:text-3xl font-semibold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-pink-400">
          Full-Stack Developer
        </h2>
        <p className="text-xl mb-8">
          <span className="font-bold text-yellow-300">Jewellery Quarter, Birmingham, UK</span><br/>
          +447471945020 | Joe_drozd@yahoo.co.uk
        </p>
        <p className="text-lg mb-8">
          3.5+ years experience at OSB Group specializing in <span className="font-bold text-yellow-300">Umbraco, C#, .NET</span> and modern web technologies
        </p>
        <button className="px-8 py-3 bg-white text-blue-600 rounded-full font-bold hover:bg-blue-100 transition-all duration-300 transform hover:scale-105 shadow-lg">
          View My Work
        </button>
      </div>
      <div className="relative">
        <img 
          src="/images/profile.jpg" 
          alt="Joseph Drozd" 
          className="w-48 h-48 md:w-64 md:h-64 rounded-full object-cover border-4 border-white/30 shadow-2xl"
        />
        <div className="absolute -inset-4 rounded-full border-2 border-white/20 animate-ping opacity-75"></div>
      </div>
    </div>
  </section>
));

export default Hero;
